{
  "version": 1,
  "asset_id": "7a4ffa9e-a801-4371-8f3e-d3a6a3e888b4",
  "project_id": "ab945133-766b-45c0-8595-d741bb5019f6",
  "url": "/__l5e/assets-v1/7a4ffa9e-a801-4371-8f3e-d3a6a3e888b4/annex-1-diagnostic-hero.png",
  "r2_key": "a/v1/ab945133-766b-45c0-8595-d741bb5019f6/7a4ffa9e-a801-4371-8f3e-d3a6a3e888b4/annex-1-diagnostic-hero.png",
  "original_filename": "annex-1-diagnostic-hero.png",
  "size": 1593369,
  "content_type": "image/png",
  "created_at": "2026-07-29T10:08:50Z"
}
